import constants from './constants';

const initialState = {
  benchmark: null,
  benchmarks: [],
  currentBenchmarks: [],
  currentSingleBenchmark: null,
  isPreviewBenchmarkDialogOpen: false,
  isPreviewSingleBenchmarkDialogOpen: false,
  isCreateBenchmarkDialogOpen: false,
  isEditBenchmarkDialogOpen: false,
  isEditBenchmarkContributionDialogOpen: false,
  isContributeBenchmarkDialogOpen: false,
  useTemplate: false,
  editMode: false,
}

const ExerciseBenchmarkReducers = (state = initialState, action) => {
  switch(action.type) {
    case constants.EXERCISE_BENCHMARK_OPEN_PREVIEW_DIALOG:
      return {
        ...state,
        isPreviewBenchmarkDialogOpen: true
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_PREVIEW_DIALOG:
      return {
        ...state,
        isPreviewBenchmarkDialogOpen: false
      }
    case constants.EXERCISE_BENCHMARK_OPEN_PREVIEW_SINGLE_DIALOG:
      return {
        ...state,
        isPreviewSingleBenchmarkDialogOpen: true,
        currentSingleBenchmark: action.payload,
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_PREVIEW_SINGLE_DIALOG:
      return {
        ...state,
        isPreviewSingleBenchmarkDialogOpen: false,
        currentSingleBenchmark: null,
      }
    case constants.EXERCISE_BENCHMARK_OPEN_CREATE_DIALOG:
      return {
        ...state,
        isCreateBenchmarkDialogOpen: true
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_CREATE_DIALOG:
      return {
        ...state,
        isCreateBenchmarkDialogOpen: false
      }
    case constants.EXERCISE_BENCHMARK_OPEN_CREATE_FROM_COPY_DIALOG:
      return {
        ...state,
        isCreateBenchmarkDialogOpen: true,
        useTemplate: true,
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_CREATE_FROM_COPY_DIALOG:
      return {
        ...state,
        isCreateBenchmarkDialogOpen: false,
        useTemplate: false,
      }
    case constants.EXERCISE_BENCHMARK_ADD_BENCHMARK:
      return {
        ...state,
        benchmarks: state.benchmarks.concat(action.payload)
      }
    case constants.EXERCISE_BENCHMARK_SET_BENCHMARKS:
      return {
        ...state,
        benchmarks: action.payload
      }
    case constants.EXERCISE_BENCHMARK_DELETE_BENCHMARK:
      return {
        ...state,
        benchmarks: state.benchmarks.filter((b) => b._id !== action.payload),
        currentBenchmarks: state.currentBenchmarks.filter((benchmark)=> benchmark._id !== action.payload)
      }
    case constants.EXERCISE_BENCHMARK_OPEN_CONTRIBUTE_DIALOG:
      return {
        ...state,
        isContributeBenchmarkDialogOpen: true,
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_CONTRIBUTE_DIALOG:
      return {
        ...state,
        isContributeBenchmarkDialogOpen: false,
      }
    case constants.EXERCISE_BENCHMARK_OPEN_EDIT_DIALOG:
      return {
        ...state,
        isEditBenchmarkDialogOpen: true,
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_EDIT_DIALOG:
      return {
        ...state,
        isEditBenchmarkDialogOpen: false,
      }
    case constants.EXERCISE_BENCHMARK_OPEN_EDIT_CONTRIBUTION_DIALOG:
      return {
        ...state,
        isEditBenchmarkContributionDialogOpen: true
      }
    case constants.EXERCISE_BENCHMARK_CLOSE_EDIT_CONTRIBUTION_DIALOG:
      return {
        ...state,
        isEditBenchmarkContributionDialogOpen: false
      }
    case constants.EXERCISE_BENCHMARK_EDIT_BENCHMARK:
      return {
        ...state,
        benchmarks: state.benchmarks.map((b) => {
          if(b._id === action.payload.id) {
            b = action.payload.data;
          }
          return b;
        }),
        currentBenchmarks: state.currentBenchmarks.map((b) => {
          if(b._id === action.payload.id) {
            b = action.payload.data;
          }
          return b;
        })
      }
    case constants.EXERCISE_BENCHMARK_ADD_TO_CURRENT_BENCHMARKS:
      return {
        ...state,
        currentBenchmarks: state.currentBenchmarks.concat(action.payload)
      }
    case constants.EXERCISE_BENCHMARK_REMOVE_FROM_CURRENT_BENCHMARKS:
      return {
        ...state,
        currentBenchmarks: state.currentBenchmarks.filter((benchmark)=> benchmark._id !== action.payload._id)
      }
    default:
      return state;
  }
}

export default ExerciseBenchmarkReducers;